function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//  @jsx h
import { bem } from '@nrk/dh-utils';
import { h } from 'preact';
import PureComponent from '../../lib/preact-pure-component';
import Video from '../Video';
var style = {
  "smartVideo": "dhfc-1_0_0-beta_48-smartVideo",
  "smartVideo__720p": "dhfc-1_0_0-beta_48-smartVideo__720p",
  "smartVideo--horizontal": "dhfc-1_0_0-beta_48-smartVideo--horizontal",
  "smartVideo--1080p": "dhfc-1_0_0-beta_48-smartVideo--1080p",
  "smartVideo__960p": "dhfc-1_0_0-beta_48-smartVideo__960p",
  "smartVideo__1080p": "dhfc-1_0_0-beta_48-smartVideo__1080p"
};
const THRESHOLD_1080P = 960;
const THRESHOLD_HORIZONTAL = 2 / 3;

class SmartVideo extends PureComponent {
  constructor() {
    super(...arguments);

    _defineProperty(this, "resolution720p", void 0);

    _defineProperty(this, "resolution960p", void 0);

    _defineProperty(this, "resolution1080p", void 0);

    _defineProperty(this, "state", {
      time: 0
    });

    _defineProperty(this, "handleTimeupdate", time => {
      const onTimeupdate = this.props.onTimeupdate;
      this.setState({
        time
      });

      if (onTimeupdate) {
        onTimeupdate(time);
      }
    });
  }

  componentDidUpdate(prevProps) {
    const prevIsHorizontal = this.isHorizontal(prevProps);
    const isHorizontal = this.isHorizontal(this.props);
    const prevIs1080p = this.is1080p(prevProps);
    const is1080p = this.is1080p(this.props);

    if (prevIsHorizontal !== isHorizontal || is1080p !== prevIs1080p) {
      this.seek(this.state.time);
    }
  }

  isHorizontal() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
    const viewport = props.viewport;

    if (this.props.isHorizontal) {
      return this.props.isHorizontal(viewport);
    } else {
      return viewport.width / viewport.height >= THRESHOLD_HORIZONTAL;
    }
  }

  is1080p() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
    const viewport = props.viewport;

    if (this.props.is1080p) {
      return this.props.is1080p(viewport);
    } else {
      return viewport.width >= THRESHOLD_1080P;
    }
  }

  seek(time) {
    const isHorizontal = this.isHorizontal();
    const is1080p = this.is1080p();

    if (isHorizontal) {
      if (is1080p) {
        this.resolution1080p.seek(time);
      } else {
        this.resolution720p.seek(time);
      }
    } else {
      this.resolution960p.seek(time);
    }
  }

  render() {
    const _this$props = this.props,
          playing = _this$props.playing,
          resolution720p = _this$props.resolution720p,
          resolution960p = _this$props.resolution960p,
          resolution1080p = _this$props.resolution1080p,
          viewport = _this$props.viewport,
          restProps = _objectWithoutProperties(_this$props, ["playing", "resolution720p", "resolution960p", "resolution1080p", "viewport"]);

    if (!resolution720p) {
      throw new Error('Missing `resolution720p` property');
    }

    if (!resolution960p) {
      throw new Error('Missing `resolution960p` property');
    }

    if (!resolution1080p) {
      throw new Error('Missing `resolution1080p` property');
    }

    const isValidViewport = viewport.width > -1 && viewport.height > -1;
    const isHorizontal = this.isHorizontal();
    const is1080p = isHorizontal && this.is1080p();
    const className = `${bem(style.smartVideo, {
      '1080p': is1080p,
      horizontal: isHorizontal
    })}${this.props.className ? ` ${this.props.className}` : ''}`;
    return h("div", {
      className: className
    }, h(Video, _extends({}, resolution720p, restProps, {
      className: style.smartVideo__720p,
      playing: isValidViewport && isHorizontal && !is1080p && playing,
      onTimeupdate: this.handleTimeupdate,
      ref: resolution720p => this.resolution720p = resolution720p
    })), h(Video, _extends({}, resolution960p, restProps, {
      className: style.smartVideo__960p,
      playing: isValidViewport && !isHorizontal && !is1080p && playing,
      onTimeupdate: this.handleTimeupdate,
      ref: resolution960p => this.resolution960p = resolution960p
    })), h(Video, _extends({}, resolution1080p, restProps, {
      className: style.smartVideo__1080p,
      playing: isValidViewport && isHorizontal && is1080p && playing,
      onTimeupdate: this.handleTimeupdate,
      ref: resolution1080p => this.resolution1080p = resolution1080p
    })));
  }

}

export default SmartVideo;